import z from "zod";
import { SourceMetadataListSchema } from "../source-metadata.schema.js";
export const ConfluencePageSubtypeSchema = z.enum(["page", "live"]);
export const ConfluenceSpaceSchema = z.object({
    id: z.string(),
    key: z.string(),
    name: z.string(),
    type: z.string(),
    status: z.string(),
    url: z.string().url(),
});
export const ConfluenceListSpacesInputSchema = z.object({
    maxResults: z.number().int().min(1).max(100).optional(),
});
export const ConfluenceListSpacesOutputSchema = z.object({
    source: z.literal("Confluence"),
    count: z.number().int(),
    spaces: z.array(ConfluenceSpaceSchema),
    message: z.string().optional(),
});
export const ConfluencePageSearchResultSchema = z.object({
    id: z.string(),
    title: z.string(),
    subtype: ConfluencePageSubtypeSchema,
    spaceKey: z.string().nullable().optional(),
    url: z.string().url(),
    excerpt: z.string().nullable().optional(),
    lastUpdated: z.string().nullable().optional(),
});
export const ConfluenceSearchInputSchema = z.object({
    query: z.string().optional().default(""),
    spaceKey: z.string().min(1).optional(),
    maxResults: z.number().int().min(1).max(25).optional(),
});
export const ConfluenceSearchOutputSchema = z.object({
    source: z.literal("Confluence"),
    query: z.string(),
    count: z.number().int(),
    pages: z.array(ConfluencePageSearchResultSchema),
    sources: SourceMetadataListSchema.optional(),
    message: z.string().optional(),
});
export const ConfluenceGetPageInputSchema = z.object({
    pageId: z.string().min(1, "Confluence page ID is required"),
});
export const ConfluencePageSchema = z.object({
    id: z.string(),
    title: z.string(),
    subtype: ConfluencePageSubtypeSchema,
    spaceKey: z.string().nullable().optional(),
    url: z.string().url(),
    text: z.string(),
    lastUpdated: z.string().nullable().optional(),
});
export const ConfluenceGetPageOutputSchema = z.object({
    source: z.literal("Confluence"),
    found: z.boolean(),
    page: ConfluencePageSchema.nullable(),
    sources: SourceMetadataListSchema.optional(),
    message: z.string().optional(),
});
export const ConfluenceUpdatePageInputSchema = z.object({
    pageId: z.string().min(1, "Confluence page ID is required"),
    content: z.string().min(1, "Page content is required"),
    title: z.string().min(1).optional(),
    versionMessage: z.string().optional(),
});
export const ConfluenceCreatePageInputSchema = z.object({
    spaceKey: z.string().min(1, "Confluence space key is required"),
    title: z.string().min(1, "Page title is required"),
    content: z.string().min(1, "Page content is required"),
    parentPageId: z.string().min(1).optional(),
});
export const ConfluenceUpdatedPageSchema = z.object({
    id: z.string(),
    title: z.string(),
    url: z.string().url(),
    version: z.number().int(),
});
export const ConfluenceUpdatePageOutputSchema = z.object({
    source: z.literal("Confluence"),
    ok: z.boolean(),
    page: ConfluenceUpdatedPageSchema,
    sources: SourceMetadataListSchema.optional(),
    message: z.string().optional(),
});
export const ConfluenceCreatePageOutputSchema = z.object({
    source: z.literal("Confluence"),
    ok: z.boolean(),
    page: ConfluenceUpdatedPageSchema,
    sources: SourceMetadataListSchema.optional(),
    message: z.string().optional(),
});
//# sourceMappingURL=confluence.schema.js.map